import { api } from '@/core/api/';
const apiUrl = 'api/appointmentcalendar';

export default {
  getStatuses() {
    return api.get(`${apiUrl}/statuses`);
  },
  getParticipants() {
    return api.get(`${apiUrl}/participants`);
  },
  getActivities() {
    return api.get(`${apiUrl}/activities`);
  },
  getAppointments(payload) {
    return api.post(`${apiUrl}/appointments`, payload);
  },
  getAppointment(id) {
    return api.get(`${apiUrl}/appointment/${id}`);
  },
  getActivity(id) {
    return api.get(`${apiUrl}/activity/${id}`);
  },
  getActivitiyParticipants(query) {
    return api.get(`${apiUrl}/activityparticipants?query=${query}`);
  },
  coordinateActivity(data) {
    return api.post(`${apiUrl}/coordinateactivity`, data);
  },
  changeAppointment(data) {
    return api.put(`${apiUrl}/changeappointment`, data);
  },
  getCaats() {
    return api.get(`${apiUrl}/caats`);
  },
  getAppointmentChangeReasons() {
    return api.get(`${apiUrl}/appointmentchangereasons`);
  },
  getReferralByNumber(referralNumber) {
    return api.get(
      `${apiUrl}/referralbynumber?referralNumber=${referralNumber}`
    );
  },
  updateParticipant(data) {
    return api.post(`${apiUrl}/appointmentupdateparticipant`, data);
  },
  cancelActivity(id) {
    return api.put(`${apiUrl}/cancelactivity/${id}`);
  },
  getActivityLog(id) {
    return api.get(`${apiUrl}/activitylog/${id}`);
  },
  getDefinedCalendarTime() {
    return api.get(`${apiUrl}/definedcalendartime`);
  },
  getFilterOptions() {
    return api.get(`${apiUrl}/filteroptions`);
  },
};
